import { createApp } from "vue";
import { createPinia } from "pinia";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import Tooltip from "@programic/vue3-tooltip";
import type { TooltipConfiguration } from '@programic/vue3-tooltip';
import * as Sentry from "@sentry/vue";
import {activeFlowId} from "@/services/observability/FlowLogger";

// Import the CSS or use your own!
import '@programic/vue3-tooltip/dist/index.css';

import '@/assets/index.css';
import LayoutLoggedIn from "@/layouts/LayoutLoggedIn.vue";
import LayoutGuest from "@/layouts/LayoutGuest.vue";
import MainButton from "@/components/buttons/MainButton.vue"

const app = createApp(App);

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_URL,
  environment: import.meta.env.VITE_ONECLICK_ENV,
  release: __APP_RELEASE__,
  ignoreErrors: ["Call cancelled"],
  integrations: [
    Sentry.vueIntegration({ attachProps: false }),
    Sentry.browserTracingIntegration({
      router,
      linkPreviousTrace: "session-storage",
      consistentTraceSampling: true,
    }),
  ],
  tracePropagationTargets: [
    import.meta.env.VITE_BASE_URL,
    import.meta.env.VITE_AUTH_BASE_URL,
  ].filter(Boolean),
  tracesSampleRate: Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE),
  beforeSendTransaction(event) {
    const flowId = activeFlowId() ?? event.contexts?.flow?.id;

    return flowId ? event : null;
  },
  enableLogs: true,
  // To disable sending user data and HTTP bodies, uncomment the line below. For more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
  dataCollection: { userInfo: false, httpBodies: [] }
});

router.onError((error, to) => {
    if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
        //@ts-ignore
        window.location = to.fullPath
    }
})

app.use(router);
app.use(createPinia());
app.use(i18n);

const options: TooltipConfiguration = {
    placement: "top",
};
app.use(Tooltip, options);

app.component("LayoutLoggedIn", LayoutLoggedIn);
app.component("LayoutGuest", LayoutGuest);
app.component("MainButton", MainButton);

app.mount("#app");
